import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_b_form_file = _resolveComponent("b-form-file");
  return _openBlock(), _createBlock(_component_b_form_file, {
    id: $props.inputId,
    size: "sm",
    modelValue: $data.valueInternal,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.valueInternal = $event;
    }),
    accept: $props.accept,
    plain: ""
  }, null, 8 /* PROPS */, ["id", "modelValue", "accept"]);
}